import type { CreatorBlock } from "@unbox/api";
import { SlashCircle01 } from "@untitledui/icons";
import { RuleSignalIcon } from "@/components/rules/rule-signal-icon";
import { RuleSourceTooltip } from "@/components/rules/rule-source-tooltip";
import { cx } from "@/utils/cx";

type CreatorBlockedBadgeProps = {
  block: Pick<CreatorBlock, "appliedBy">;
  label?: string;
  className?: string;
};

export const CreatorBlockedBadge = ({ block, label = "Creator Blocked", className }: CreatorBlockedBadgeProps) => {
  const Icon = block.appliedBy?.source === "rule" ? RuleSignalIcon : SlashCircle01;

  return (
    <RuleSourceTooltip appliedBy={block.appliedBy} action="blocked">
      <span className={cx("inline-flex items-center gap-1.5 text-xs font-medium text-error-primary", className)}>
        {label}
        <Icon className="size-3.5 shrink-0" />
      </span>
    </RuleSourceTooltip>
  );
};
